import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Chip, Stack } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import moment from "moment";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import * as React from "react";

const menuData = [
  {
    title: "Edit this day",
    type: "editDay",
  },
  {
    title: "Add time off",
    type: "timeOff",
  },
  {
    title: "Delete this shift",
    type: "deleteShift",
  },
];

const addShift = [
  {
    title: "Add shift",
    type: "editDay",
  },
  {
    title: "Add time off",
    type: "timeOff",
  },
];

export default function ScheduleEditMenu({ value, handleSelectOption, width }) {
  console.log(value, "valuevaluevalue");

  const menuItems = value?.length === 0 ? addShift : menuData;

  const renderAddAnotherBtn = () => {
    const addShift = [
      {
        title: "Add shift",
        type: "editDay",
      },
      {
        title: "Add time off",
        type: "timeOff",
      },
    ];
    return (
      <PopupState variant="popover" popupId="demo-popup-menu">
        {(popupState) => (
          <React.Fragment>
            <Box
              sx={{
                "&:hover": {
                  "& .add-new": {
                    visibility: "hidden",
                  },
                },
              }}
            >
              <Box
                className="add-new"
                sx={{
                  backgroundColor: "#FDEEE6",
                  borderRadius: 1,
                  cursor: "pointer",
                  visibility: "hidden",
                }}
                textAlign={"center"}
                {...bindTrigger(popupState)}
              >
                <AddCircleOutlineIcon sx={{ fontSize: "1rem" }} />
              </Box>
            </Box>
            <Menu {...bindMenu(popupState)}>
              {addShift.map((val, _ind) => (
                <MenuItem
                  key={_ind}
                  onClick={() => {
                    handleSelectOption(val.type);
                    popupState.close();
                  }}
                  sx={{
                    fontSize: "0.875rem",
                  }}
                >
                  {val.title}
                </MenuItem>
              ))}
            </Menu>
          </React.Fragment>
        )}
      </PopupState>
    );
  };

  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          {value?.length === 0 ? (
            <Box
              sx={{
                transition: "visibility 0.2s",
                "&:hover": {
                  "& .add-icon": {
                    visibility: "hidden",
                  },
                },
              }}
              textAlign={"center"}
              // {...bindTrigger(popupState)}
            >
              {/* <AddCircleOutlineIcon
                fontSize="small"
                className="add-icon"
                sx={{ cursor: "pointer", visibility: "hidden" }}
              /> */}
            </Box>
          ) : null}
          {value?.length > 0 ? (
            <Stack gap={0.5}>
              {value.map((item, _i) => (
                <Chip
                  key={_i}
                  sx={{
                    backgroundColor: "#FDEEE6",
                    borderRadius: 1,
                    fontSize: "0.75rem",
                    "&:hover": {
                      backgroundColor: "#fbe6db",
                    },
                    "& .MuiChip-label": {
                      pl: "2px",
                    },
                  }}
                  label={`${moment(item.startTime).format("h:a")}-${moment(
                    item.endTime
                  ).format("h:mma")}`}
                  // {...bindTrigger(popupState)}
                />
              ))}
            </Stack>
          ) : (
            <Chip
              sx={{
                backgroundColor: "#F5F1F1",
                borderRadius: 1,
                width: "100%",
                fontSize: "0.75rem",
                "&:hover": {
                  backgroundColor: "#fbe6db",
                },
                "& .MuiChip-label": {
                  pl: "2px",
                },
              }}
              label={"Holy Day"}
              // {...bindTrigger(popupState)}
            />
          )}
          <Menu {...bindMenu(popupState)}>
            {menuItems.map((val, _ind) => (
              <MenuItem
                key={_ind}
                onClick={() => {
                  handleSelectOption(val.type);
                  popupState.close();
                }}
                sx={{
                  fontSize: "0.875rem",
                  color: val.type === "deleteShift" ? "red" : "inherit",
                }}
              >
                {val.title}
              </MenuItem>
            ))}
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
